<script>
  import { checkbox } from 'vue-strap';
  import solicitacaoImportacaoServico from '../../servico';
  import converterMoeda from '~js/converter-moeda';

  export default {
    components: { checkbox },
    props: {
      solicitacao: Object,
      edicao: Boolean,
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        moedas: [],
        formapagamentos: [],
        incoterm: [],
        previsaoentregas: [],
        tiposEmbarque: [],
        destinosCarga: [],
        bancos: [],
        agencias: [],
        contas: [],
        configuracao: this.$storage.configuracao(),
        obrigatorioEndereco: false,
        desabilitarEndereco: false,
      }
    },
    computed: {
      observacaoSolicitacaoContador: function() {
        let quantidadeCaracteres = this.solicitacao.observacaoSolicitacao ? 
          this.solicitacao.observacaoSolicitacao.length : 0;

        return 500 - quantidadeCaracteres;
      },
      validarInformacoesFornecedores: function() {
        return this.configuracao.obrigatorioIndicarFornecedoresImportacao ? 'required' : '';
      },
    },
    methods: {
      listaDeBancos() {
        return solicitacaoImportacaoServico
          .listaBancos()
          .then(bancos => {
            this.bancos = bancos;
          });
      },
      listaDeMoedas() {
        return solicitacaoImportacaoServico
          .listaMoedas()
          .then(moedas => {
            this.moedas = moedas;
          });
      },
      listaDeFormaPagamentos() {
        return solicitacaoImportacaoServico
          .listaFormaPagamentos()
          .then(formapagamentos => {
            this.formapagamentos = formapagamentos;
          });
      },
      listaDeIncoterm() {
        return solicitacaoImportacaoServico
          .listaIncoterm()
          .then(incoterm => {
            this.incoterm = incoterm;
          });
      },
      listaDePrevisaoEntregas() {
        return solicitacaoImportacaoServico
          .listaPrevisaoEntregas()
          .then(previsaoentregas => {
            this.previsaoentregas = previsaoentregas;
          });
      },
      listaDeTipoEmbarque() {
        return solicitacaoImportacaoServico
          .listaTipoEmbarque()
          .then(tiposembarque => {
            this.tiposEmbarque = tiposembarque;
          });
      },
      listaDeDestinoCarga() {
        return solicitacaoImportacaoServico
          .listaDestinoCarga()
          .then(destinoscarga => {
            this.destinosCarga = destinoscarga;
          });
      },
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao(valido) {
        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
      getCotacaoEstimada(idMoeda) {
        return solicitacaoImportacaoServico
        .getCotacaoEstimada(idMoeda)
            .then(dados => {
                this.solicitacao.cotacaoEstimada = converterMoeda.paraCambio(dados.valorCotacao);
            })
            .catch(erro => {
                this.solicitacao.cotacaoEstimada = converterMoeda.paraCambio(1.0);
            });
      },
      setarMoeda(event) {
        this.moedas.map(moeda => {
        if (moeda.idImportacaoMoeda == event.target.value) {
            this.$set(this.solicitacao, 'importacaoMoeda', moeda);
            this.$set(this.solicitacao, 'idMoeda', moeda.idImportacaoMoeda);
            this.getCotacaoEstimada(moeda.idImportacaoMoeda);
          }
        });
      },
    },
    mounted() {
      this.$events.on('carregarMoedas', this.listaDeMoedas);
      this.$events.on('carregarFormaPagamentos', this.listaDeFormaPagamentos);
      this.$events.on('carregarIncoterm', this.listaDeIncoterm);
      this.$events.on('carregarPrevisaoEntregas', this.listaDePrevisaoEntregas);
      this.$events.on('carregarTipoEmbarque', this.listaDeTipoEmbarque);
      this.$events.on('carregarDestinoCarga', this.listaDeDestinoCarga);
      this.$events.on('carregarBancos', this.listaDeBancos);
    },
    watch: {

    }
  }
</script>

<template>
    <div>
        <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
            <div class="btn-group" role="group">
                <button type="button" :class="['btn btn-primary', {'active': true}]">
                    Números de Controle
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group" :class="{'has-error': errors.has('dataProforma')}">
                    <label class="control-label" for="dataProforma">Data da Proforma</label>

                    <input type="text"
                           class="form-control"
                           id="dataProforma"
                           v-mascara="'data'"
                           placeholder="    /    /"
                           v-validate="'date_format:DD/MM/YYYY'"
                           data-vv-name="dataProforma"
                           data-vv-as="data  proforma"
                           v-model="solicitacao.dataProforma">

                    <p class="text-danger" v-show="errors.has('dataProforma')">{{ errors.first('dataProforma') }}</p>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group" :class="{'has-error': errors.has('numeroProformaInvoice')}">
                    <label class="control-label" for="numeroProformaInvoice">N° Proforma Invoice</label>

                    <input type="text"
                           class="form-control"
                           id="numeroProformaInvoice"
                           data-vv-name="numeroProformaInvoice"
                           v-model="solicitacao.numeroProformaInvoice"
                           data-vv-as="número proforma invoice"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('numeroProformaInvoice')">{{ errors.first('numeroProformaInvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group" :class="{'has-error': errors.has('validadeProposta')}">
                    <label class="control-label" for="validadeProposta">Validade Proposta</label>

                    <input type="text"
                           class="form-control"
                           id="validadeProposta"
                           data-vv-name="validadeProposta"
                           v-model="solicitacao.validadeProposta"
                           data-vv-as="validade proposta"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('validadeProposta')">{{ errors.first('validadeProposta') }}</p>
                </div>
            </div>
        </div>

        <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
            <div class="btn-group" role="group">
                <button type="button" :class="['btn btn-primary', {'active': true}]">
                    Dados do Exportador
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-5">
                <div class="form-group">
                    <label class="control-label" for="nomeexportador">Nome exportador</label>

                    <input type="text"
                           class="form-control"
                           id="nomeexportador"
                           data-vv-name="nomeexportador"
                           data-vv-as="nome exportaador"
                           v-model="solicitacao.nomeExportador"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomeexportador')">{{ errors.first('nomeexportador') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="emailexportador">Email</label>

                    <input type="text"
                           class="form-control"
                           id="emailexportador"
                           data-vv-name="emailexportador"
                           data-vv-as="email exportador"
                           v-model="solicitacao.emailExportador"
                           maxlength="300">

                    <p class="text-danger" v-show="errors.has('emailexportador')">{{ errors.first('emailexportador') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group">
                    <label class="control-label" for="siteexportador">Site</label>

                    <input type="text"
                           class="form-control"
                           id="siteexportador"
                           data-vv-name="siteexportador"
                           data-vv-as="site exportador"
                           v-model="solicitacao.siteExportador"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('siteempresainvoice')">{{ errors.first('siteempresainvoice') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="telefone1exportador">Telefone 1</label>

                    <input type="text"
                           class="form-control"
                           id="telefone1exportador"
                           data-vv-name="telefone1exportador"
                           v-model="solicitacao.telefone1Exportador"
                           data-vv-as="telefone 1"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('telefone1exportador')">{{ errors.first('telefone1exportador') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="telefone2exportador">Telefone 2</label>

                    <input type="text"
                           class="form-control"
                           id="telefone2exportador"
                           data-vv-name="telefone2exportador"
                           v-model="solicitacao.telefone2Exportador"
                           data-vv-as="telefone 2"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('telefone2exportador')">{{ errors.first('telefone2exportador') }}</p>
                </div>
            </div>

            <div class="col-sm-8">
                <div class="form-group">
                    <label class="control-label" for="enderecoexportador">Endereço</label>

                    <input type="text"
                           class="form-control"
                           id="enderecoexportador"
                           data-vv-name="enderecoexportador"
                           data-vv-as="endereço exportador"
                           v-model="solicitacao.enderecoExportador"
                           maxlength="300">

                    <p class="text-danger" v-show="errors.has('enderecoexportador')">{{ errors.first('enderecoexportador') }}</p>
                </div>
            </div>
        </div>

        <div class="row">           
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="zipcodeexportador">ZIP Code</label>

                    <input type="text"
                           class="form-control"
                           id="zipcodeexportador"
                           data-vv-name="zipcodeexportador"
                           data-vv-as="ZIP code exportador"
                           v-model="solicitacao.zipCodeExportador"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('zipcodeexportador')">{{ errors.first('zipcodeexportador') }}</p>
                </div>
            </div>

            <div class="col-sm-5">
                <div class="form-group">
                    <label class="control-label" for="cidadeexportador">Cidade</label>

                    <input type="text"
                           class="form-control"
                           id="cidadeexportador"
                           data-vv-name="cidadeexportador"
                           data-vv-as="cidade exportador"
                           v-model="solicitacao.cidadeExportador"
                           maxlength="40">

                    <p class="text-danger" v-show="errors.has('cidadeexportador')">{{ errors.first('cidadeexportador') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="estadoexportador">Estado</label>

                    <input type="text"
                           class="form-control"
                           id="estadoexportador"
                           data-vv-name="estadoexportador"
                           data-vv-as="estado exportador"
                           v-model="solicitacao.estadoExportador"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('estadoexportador')">{{ errors.first('estadoexportador') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="paisexportador">País</label>

                    <input type="text"
                           class="form-control"
                           id="paisexportador"
                           data-vv-name="paisexportador"
                           data-vv-as="país exportador"
                           v-model="solicitacao.paisExportador"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('paisexportador')">{{ errors.first('paisexportador') }}</p>
                </div>
            </div>
        </div>

        <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
            <div class="btn-group" role="group">
                <button type="button" :class="['btn btn-primary', {'active': true}]">
                    Representante no Brasil
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label" for="nomeempresainvoice">Nome empresa</label>

                    <input type="text"
                           class="form-control"
                           id="nomeempresainvoice"
                           data-vv-name="nomeempresainvoice"
                           data-vv-as="nome empresa invoice"
                           v-model="solicitacao.nomeEmpresaInvoice"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomeempresainvoice')">{{ errors.first('nomeempresainvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="contatoempresainvoice">Contato empresa</label>

                    <input type="text"
                           class="form-control"
                           id="contatoempresainvoice"
                           data-vv-name="contatoempresainvoice"
                           data-vv-as="contato empresa invoice"
                           v-model="solicitacao.contatoEmpresaInvoice"
                           maxlength="200">

                    <p class="text-danger" v-show="errors.has('contatoempresainvoice')">{{ errors.first('contatoempresainvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="emailEmpresaInvoice">Email</label>

                    <input type="text"
                           class="form-control"
                           id="emailinvoice"
                           data-vv-name="emailinvoice"
                           data-vv-as="email invoice"
                           v-model="solicitacao.emailEmpresaInvoice"
                           maxlength="300">

                    <p class="text-danger" v-show="errors.has('emailinvoice')">{{ errors.first('emailinvoice') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <div class="form-group">
                    <label class="control-label" for="siteempresainvoice">Site</label>

                    <input type="text"
                           class="form-control"
                           id="siteempresainvoice"
                           data-vv-name="siteempresainvoice"
                           data-vv-as="site empresa invoice"
                           v-model="solicitacao.siteEmpresaInvoice"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('siteempresainvoice')">{{ errors.first('siteempresainvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="telefone1empresainvoice">Telefone 1</label>

                    <input type="text"
                           class="form-control"
                           id="telefone1empresainvoice"
                           data-vv-name="telefone1empresainvoice"
                           v-model="solicitacao.telefone1EmpresaInvoice"
                           data-vv-as="telefone 1"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('telefone1empresainvoice')">{{ errors.first('telefone1empresainvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="telefone2empresainvoice">Telefone 2</label>

                    <input type="text"
                           class="form-control"
                           id="telefone2empresainvoice"
                           data-vv-name="telefone2empresainvoice"
                           v-model="solicitacao.telefone2EmpresaInvoice"
                           data-vv-as="telefone 2"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('telefone2empresainvoice')">{{ errors.first('telefone2empresainvoice') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group">
                    <label class="control-label" for="paisempresainvoice">País</label>

                    <input type="text"
                           class="form-control"
                           id="paisempresainvoice"
                           data-vv-name="paisempresainvoice"
                           data-vv-as="país empresa invoice"
                           v-model="solicitacao.paisEmpresaInvoice"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('paisempresainvoice')">{{ errors.first('paisempresainvoice') }}</p>
                </div>
            </div>
        </div>

        <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
            <div class="btn-group" role="group">
                <button type="button" :class="['btn btn-primary', {'active': true}]">
                    Condições Gerais das compras (INCOTERMS)
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3">
                <div class="form-group" :class="{'has-error': errors.has('formapagamento')}">
                    <label class="control-label" for="formapagamento">Forma Pagamento</label>

                    <select class="form-control"
                            id="formapagamento"
                            data-vv-name="formapagamento"
                            data-vv-as="forma de pagamento"
                            v-model="solicitacao.idImportacaoFormaPagamento">
                        <option value="" selected>Selecione...</option>
                        <option :value="formapagamento.idImportacaoFormaPagamento" v-for="formapagamento in formapagamentos">{{ formapagamento.formaPagamento }}</option>
                    </select>
                    <p class="text-danger" v-show="errors.has('formapagamento')">{{ errors.first('formapagamento') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group" :class="{'has-error': errors.has('previsaoEntrega')}">
                    <label class="control-label" for="previsaoEntrega">Previsão de Entrega</label>

                    <select class="form-control"
                            id="previsaoEntrega"
                            data-vv-name="previsaoEntrega"
                            data-vv-as="previsão de entrega"
                            v-model="solicitacao.idImportacaoPrevisaoEntrega">
                        <option value="" selected>Selecione...</option>
                        <option :value="previsaoentrega.idImportacaoPrevisaoEntrega" v-for="previsaoentrega in previsaoentregas">{{ previsaoentrega.previsaoEntrega }}</option>
                    </select>
                    <p class="text-danger" v-show="errors.has('previsaoEntrega')">{{ errors.first('previsaoEntrega') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group" :class="{'has-error': errors.has('incoterm')}">
                    <label class="control-label" for="incoterm">Incoterm</label>

                    <select class="form-control"
                            id="incoterm"
                            data-vv-name="incoterm"
                            data-vv-as="incoterm"
                            v-model="solicitacao.idImportacaoIncoterm">
                        <option value="" selected>Selecione...</option>
                        <option :value="incoterm.idImportacaoIncoterm" v-for="incoterm in incoterm">{{ incoterm.incoterm }}</option>
                    </select>
                    <p class="text-danger" v-show="errors.has('incoterm')">{{ errors.first('incoterm') }}</p>
                </div>
            </div>

            <div class="col-sm-2">

                <div class="form-group" :class="{'has-error': errors.has('moeda')}">
                    <label class="control-label" for="moeda">Moeda</label>

                    <select class="form-control"
                            id="moeda"
                            data-vv-name="moeda"
                            data-vv-as="moeda"
                            v-model="solicitacao.idMoeda"
                            @change="setarMoeda($event)"
                            v-validate="'required'">
                        <option value="" selected>Selecione...</option>
                        <option :value="moeda.idImportacaoMoeda" v-for="moeda in moedas">{{ moeda.nomeMoeda }}</option>
                    </select>
                    <p class="text-danger" v-show="errors.has('moeda')">{{ errors.first('moeda') }}</p>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="cotacaoEstimada">Cotação estimada</label>

                    <input type="text"
                           :disabled="true"
                           class="form-control"
                           id="cotacaoEstimada"
                           data-vv-name="cotacaoEstimada"
                           data-vv-as="cotação estimada"
                           v-model="solicitacao.cotacaoEstimada">

                    <p class="text-danger" v-show="errors.has('cotacaoEstimada')">{{ errors.first('cotacaoEstimada') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="outrasCondicoesCompra">
                        Outras Condições Gerais das Compras (INCOTERMS)
                    </label>

                    <textarea class="form-control"
                              id="outrasCondicoesCompra"
                              v-model="solicitacao.outrasCondicoesCompra">
          </textarea>
                </div>
            </div>
        </div>

        <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
            <div class="btn-group" role="group">
                <button type="button" :class="['btn btn-primary', {'active': true}]">
                    Dados Bancários Exportador
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <div class="form-group">
                    <label class="control-label" for="instituicaoFinanceira">Instituição Financeira</label>

                    <input type="text"
                           class="form-control"
                           id="instituicaoFinanceira"
                           data-vv-name="instituicaoFinanceira"
                           data-vv-as="instituição financeira"
                           v-model="solicitacao.instituicaoFinanceira"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('instituicaoFinanceira')">{{ errors.first('instituicaoFinanceira') }}</p>
                </div>
            </div>

            <div class="col-sm-5">
                <div class="form-group">
                    <label class="control-label" for="enderecoAgencia">Endereço da Agência</label>

                    <input type="text"
                           class="form-control"
                           id="enderecoAgencia"
                           data-vv-name="enderecoAgencia"
                           data-vv-as="endereço agência"
                           v-model="solicitacao.enderecoAgencia"
                           maxlength="200">

                    <p class="text-danger" v-show="errors.has('enderecoAgencia')">{{ errors.first('enderecoAgencia') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="numeroAgencia">Número Agência</label>

                    <input type="text"
                           class="form-control"
                           id="numeroAgencia"
                           data-vv-name="numeroAgencia"
                           data-vv-as="número agênciar"
                           v-model="solicitacao.numeroAgencia"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('numeroAgencia')">{{ errors.first('numeroAgencia') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="numeroConta">Número da Conta</label>

                    <input type="text"
                           class="form-control"
                           id="numeroConta"
                           data-vv-name="numeroConta"
                           data-vv-as="número da conta"
                           v-model="solicitacao.numeroConta"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('numeroConta')">{{ errors.first('numeroConta') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group">
                    <label class="control-label" for="iban">IBAN</label>

                    <input type="text"
                           class="form-control"
                           id="iban"
                           data-vv-name="iban"
                           data-vv-as="IBAN"
                           v-model="solicitacao.iban"
                           maxlength="50">

                    <p class="text-danger" v-show="errors.has('iban')">{{ errors.first('iban') }}</p>
                </div>
            </div>

            <div class="col-sm-5">
                <div class="form-group">
                    <label class="control-label" for="SWFITCode">
                        SWFIT Code
                    </label>

                    <input type="text"
                           class="form-control"
                           id="SWFITCode"
                           data-vv-name="SWFITCode"
                           data-vv-as="SWFIT Code"
                           v-model="solicitacao.swfitCode"
                           maxlength="50">

                    <p class="text-danger" v-show="errors.has('SWFITCode')">{{ errors.first('SWFITCode') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="informacoesComplementares">
                        Informações Complementares
                    </label>

                    <textarea class="form-control"
                              id="informacoesComplementares"
                              v-model="solicitacao.informacoesComplementares">
          </textarea>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-solicitacao">
                        Observação da Solicitação/Detalhes ({{ observacaoSolicitacaoContador }})
                    </label>

                    <textarea class="form-control"
                              id="observacao-solicitacao"
                              v-model="solicitacao.observacaoSolicitacao"
                              maxlength="500">
                    </textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/compartilhado/FormDadosProforma.vue